export const STYLING_VALUE_BACKGROUND_POSITION_FILL = 'fill';
export const STYLING_VALUE_BACKGROUND_POSITION_TILE = 'tile';
export const STYLING_VALUE_BORDER_STYLE_DASHED = 'dashed';
export const STYLING_VALUE_BORDER_STYLE_DOTTED = 'dotted';
export const STYLING_VALUE_BORDER_STYLE_DOUBLE = 'double';
export const STYLING_VALUE_BORDER_STYLE_GROOVE = 'groove';
export const STYLING_VALUE_BORDER_STYLE_INSET = 'inset';
export const STYLING_VALUE_BORDER_STYLE_NONE = 'none';
export const STYLING_VALUE_BORDER_STYLE_OUTSET = 'outset';
export const STYLING_VALUE_BORDER_STYLE_RIDGE = 'ridge';
export const STYLING_VALUE_BORDER_STYLE_SOLID = 'solid';
export const STYLING_VALUE_FONT_STYLE_ITALIC = 'italic';
export const STYLING_VALUE_FONT_STYLE_NORMAL = 'normal';
export const STYLING_VALUE_FONT_WEIGHT_BOLD = 'bold';
export const STYLING_VALUE_FONT_WEIGHT_NORMAL = 'normal';
export const STYLING_VALUE_STICK_TO_LEFT = 'left';
export const STYLING_VALUE_STICK_TO_TOP = 'top';
export const STYLING_VALUE_TEXT_DECORATION_NONE = 'none';
export const STYLING_VALUE_TEXT_DECORATION_UNDERLINE = 'underline';
export const STYLING_VALUE_TEXT_TRANSFORM_NONE = 'none';
export const STYLING_VALUE_TEXT_TRANSFORM_UPPERCASE = 'uppercase';
